export class Grupo {
  selector: string;
  nome: string;
}